import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function getUserBadges(userId) {
  if (!userId) {
    return Promise.resolve({ response: null, data: null });
  }

  return fetchWrapper.get(`${config.apis.api.url}/user/${encodeURIComponent(userId)}/badges`, {
    injectToken: true,
  });
}

function claimBadge(userId, badgeName) {
  if (!userId || !badgeName) {
    return Promise.resolve({ response: null, data: null });
  }

  const endpoint = `${config.apis.api.url}/user/${encodeURIComponent(userId)}/badges/${encodeURIComponent(badgeName)}/claim`;
  return fetchWrapper.put(endpoint, {
    injectToken: true,
  });
}

export default {
  getUserBadges,
  claimBadge,
};
